import store from 'Store'

const isOptionInRelation  = function (liquidTemplate, keygroupType, optionName) {
  //find out if a certain ui option belongs to a type of keygroup
  if (liquidTemplate && keygroupType) {
    return liquidTemplate.relations[keygroupType].includes(optionName)
  } else {
    return false
  }
}

const createKeygroupLiquidPayload = function (liquidTemplate, keygroup, uiData) {
  //set up the keys, only send the relevant keys to the current type
  let keys = {}
  if (keygroup) {
    const basekey = keygroup.basenumber * 10

    const options = ['location','type','imageurl1','imageurl2','imageurl3','embroideryurl','text1','text2','text3','text4','truetypefont','wilcomfont','fontcolor','imprinttype',]

    if (uiData.type !== 'BASIC') {
      options.forEach(element => {
        if (isOptionInRelation( liquidTemplate, uiData.type, element)) {
          keys['fv' + (basekey + liquidTemplate.options[element].key)] = uiData[element]
        }
      });
      if (isOptionInRelation( liquidTemplate, uiData.type, 'embroiderycolors')) {
        keys['fv' + (basekey + 3)] = uiData.embroiderycolors.join('~')
      }
    }
  }
  return keys
}

const updateMaterialFromKeygroups = function () {
  //go over all keygroups and assemble the full liquid setup
  const keygroups = store.state.keygroups.all
  let liquid = {}
  keygroups.forEach(keygroup => {
    if (keygroup.liquid) {
      const templiquid = {...liquid, ...keygroup.liquid}
      liquid = templiquid
    }
  });
  return liquid
}

const injectProductId = function (liquidname, liquiddata) {
  const liquid = store.getters['liquid/getItemByName'](liquidname)
  liquiddata.prodID = liquid.prodID
}

export default {
  isOptionInRelation, 
  createKeygroupLiquidPayload,
  updateMaterialFromKeygroups,
  injectProductId
}